import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { ComAcLevelsComponent } from "@irb/irb-editors/editor-security/com-ac-levels/com-ac-levels.component";

@Injectable({
    providedIn: 'root'
})
export class ComAcLevelsGridLayoutService implements GridLayoutService<ComAcLevelsComponent> {
    constructor(private util: UtilityService) {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Schwab Asset Classes',
            children: [
                    {
                        headerName: "Level 1",
                        field: "acLevel1",
                        flex: 1,
                        cellRenderer : 'cellRendererFormatter'
                    },    
                    {
                        headerName: "Level 2",
                        field: "acLevel2",
                        flex: 1,
                        cellRenderer : 'cellRendererFormatter'
                    },    
                    {
                        headerName: "Level 3",
                        field: "acLevel3",
                        flex: 1,
                        cellRenderer : 'cellRendererFormatter'
                    },    
                    {
                        headerName: "Level 4",
                        field: "acLevel4",
                        flex: 1,
                        cellRenderer : 'cellRendererFormatter'
                    },    
                    {
                        headerName: "% Allocation",
                        field: "allocation",
                        width: 120,
                        cellRenderer : 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: '%',isCashSecuritySymbol:true,decimalPosition : '2'},
                        comparator: this.util.sortAsNumber
                    } 
                ]
        }];
    }
}
